// Dates and times, formatted explicitly rather than left to the browser's locale. Unset locale
// meant en-US: "9:00 PM" and "7/14/2026" — 12-hour is wrong for a match schedule, and 7/14 vs 14/7
// is genuinely ambiguous to everyone outside the US. Fixed options render the same everywhere.

/** "Tue 21 Jul 21:00" — 24h, day before month. */
export const fmtFixture = (epochSec: number): string =>
  new Date(epochSec * 1000).toLocaleString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })

/** "14 Jul 2026" — month named, so the order can't be misread. */
export const fmtDate = (epochSec: number): string =>
  new Date(epochSec * 1000).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })

/** "14 Jul 2026, 21:00" for ISO timestamps (AI generatedAt). */
export const fmtStamp = (iso: string): string =>
  new Date(iso).toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })

/** Median, not mean: one round where a player idles in spawn for 90s would drag an average and
 *  misdescribe how the team actually plays. */
export function median(xs: number[]): number | null {
  if (!xs.length) return null
  const s = [...xs].sort((a, b) => a - b)
  const m = s.length >> 1
  return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2
}

/** Under ~25s to the site is a set play; 40s+ is a default. Naming it beats a bare number. */
export const paceLabel = (secs: number): string => (secs <= 25 ? 'fast' : secs >= 40 ? 'default' : 'mixed')

/** "1v1 9/12 · 1v2 4/21" — the flat clutch total hides whether they win anything hard. */
export const clutchTitle = (by?: Record<string, { w: number; p: number }>): string => {
  const parts = Object.entries(by ?? {})
    .sort()
    .filter(([, v]) => v.p > 0)
    .map(([k, v]) => `${k} ${v.w}/${v.p}`)
  return parts.length ? parts.join(' · ') : 'no clutch situations'
}
